
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)","fill":"currentColor"}},[_c('path',{attrs:{"d":"M15.829 3.879L12.12.17A.588.588 0 0011.707 0H.585A.585.585 0 000 .585v14.83c0 .323.262.585.585.585h14.83a.585.585 0 00.585-.585V4.293a.585.585 0 00-.171-.414zM4.879 1.17h6.243v3.463H4.878V1.17zm7.635 13.658H3.486V9.904h9.028v4.925zm2.315 0h-1.144V9.32a.585.585 0 00-.586-.586H2.901a.585.585 0 00-.586.586v5.51H1.171V1.171h2.536v4.048c0 .324.262.586.586.586h7.414a.585.585 0 00.586-.586V2l2.536 2.536V14.83z"}}),_c('path',{attrs:{"d":"M9.672 1.719a.585.585 0 00-.585.585V3.5a.585.585 0 101.17 0V2.304a.585.585 0 00-.585-.585z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"currentColor","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    